
   <template>
    <div id="app">
      <b-card>
        <b-card-header>
          <b-card-title>Complaint Resolution Time Analysis</b-card-title>
        </b-card-header>
        <apexchart
          type="line"
          :height="chartOptions.chart.height"
          :options="chartOptions"
          :series="series"
        />
      </b-card>
    </div>
  </template>
  
  <script>
  import VueApexCharts from "vue-apexcharts";
  import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";
  
  export default {
    name: "ComplaintResolutionTime",
    components: {
      apexchart: VueApexCharts,
      BCard,
      BCardHeader,
      BCardTitle,
    },
    props: {
      data: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        series: [
          {
            name: "Average Resolution Time (Days)",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "line",
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "straight",
          },
          grid: {
            row: {
              colors: ["#f3f3f3", "transparent"],
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: [], 
            title: {
              text: "Month-Year",
            },
          },
          yaxis: {
            title: {
              text: "Average Resolution Time (Days)",
            },
          },
          tooltip: {
            theme: "dark",
            y: {
              formatter: function (val) {
                return `${val.toFixed(2)} days`;
              },
            },
          },
        },
      };
    },
    watch: {
      data: {
        immediate: true,
        handler(newData) {
          if (newData && newData.length > 0) {
            this.updateChart(newData);
          }
        }
      }
    },
    methods: {
      updateChart(data) {
        // Sort data by year and month
        const sortedData = [...data].sort((a, b) => {
          if (a.year !== b.year) return a.year - b.year;
          return a.month - b.month;
        });

        // Format x-axis labels and get resolution times
        const categories = sortedData.map(item => {
          const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          return `${monthNames[item.month - 1]} ${item.year}`;
        });

        const resolutionTimes = sortedData.map(item => 
          Number(item.averageResolutionDays.toFixed(2))
        );

        // Update chart data
        this.series = [{
          name: "Average Resolution Time (Days)",
          data: resolutionTimes
        }];

        // Update x-axis categories
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: {
            ...this.chartOptions.xaxis,
            categories: categories
          }
        };
      }
    }
  };
  </script>
  
  <style scoped>
  #app {
    width: 100%;
    height: 100%;
    margin: 20px;
  }
  
  @media (max-width: 768px) {
    #app {
      margin: 10px;
    }
  }
  </style>